export default {
    id: "StudentSettings",
    code: "CN",
    text: {
      'Other Info': '其他信息',        
      'Add New': '添加',
      'New Field': '新标题',
      'Type': '类型',
      'Label': '标题',
      'New Field': '新标题',
      'Set As Required': '设为必填',
      'Options': '选项',
      'Add Option': '添加选项',
      'Text': '文本框',
      'Select One': '单选框',
      'Select Multiple': '复选框',
      'Remove Field': '删除框',
      'Are you sure you want to remove the field?': '你确定要删除此框？',
      'Save': '保存'
    }
  }
  


// WEBPACK FOOTER //
// ./src/components/UI/CustomField/locale.js